import { RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { ForgotPassword } from "./ForgotPassword";
import { routes } from "./ForgotPassword.Parts";

// LOADER

// WRAPPER

// ROUTE
export const ForgotPasswordRouteObject: RouteObject = {
  path: routes.password.forgotPassword,
  errorElement: <GeneralErrorPage />,
  Component: ForgotPassword,
};
